import React, {useContext, useEffect, useState} from "react";

// Services
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";
import {NotificationsContext} from "../../../ui-components/Notifications";
import {useIntl} from "react-intl";

// Components
import KpiConfigurationBarChart from "../../../components/Charts/KpiConfigurationBarChart";
import {PageSection} from "../../../ui-components/Container";
import Placeholder from "../../../ui-components/Placeholder";

// Types
import {AnalyticsConfigurationsProps, ConfigurationRow} from "./Configurations.type";
import {FormatNumberOptions} from "react-intl";

const currencyOption: FormatNumberOptions = {style: 'currency', currency: 'EUR', maximumFractionDigits: 0}


export function AnalyticsConfigurations(
  {
    visibilityUserIds,
    analysisPeriod,
    worksitesOwnershipFilter
  }: AnalyticsConfigurationsProps
) {

  const intl = useIntl();
  const [loading, setLoading] = useState(true);
  const {push} = useContext(NotificationsContext);
  const countryApiRequest = useCountryAxiosInstance();

  const [configurations, setConfigurations] = useState<ConfigurationRow[] | undefined>(undefined);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const [configurations] = await Promise.all([
          // @ts-ignore
          countryApiRequest.post("/analytics/configurations", {
            start_date: analysisPeriod.start,
            end_date: analysisPeriod.end,
            visibility_user_ids: visibilityUserIds,
            worksites_ownership: worksitesOwnershipFilter,
          }),
        ]);
        // @ts-ignore
        setConfigurations(configurations)

      } catch (error) {
        console.log(error)
        push({title: intl.formatMessage({id: "server_error"}), type: "error"});
      } finally {
        setLoading(false)
      }
    };

    fetchData()

  }, [visibilityUserIds, analysisPeriod, worksitesOwnershipFilter]) // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="w-full">
    {!loading && configurations ?
      <div>
        <PageSection
          title={<span className="font-bold">{intl.formatMessage({id: "configurations"})}</span>}
          description={undefined}
        >
          {configurations.length ?
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 lg:gap-x-4 gap-y-4 -mb-8">
              <div>
                <div className="flex flex-row">
                  <div className="p-2 w-full">
                    <span className="text-lg text-gray-500 font-bold m-1">
                      {intl.formatMessage({id: "total"})}
                    </span>
                    <span className="text-lg text-gray-700 font-bold m-1">
                      {intl.formatNumber(configurations.reduce((acc, i) => acc + i.val_configurations, 0))}
                    </span>
                  </div>
                  <div className="p-2 w-full">
                    <span className="text-lg text-gray-500 font-bold m-1">
                      {intl.formatMessage({id: "completed"})}
                    </span>
                    <span className="text-lg text-gray-700 font-bold m-1">
                      {intl.formatNumber(configurations.reduce((acc, i) => acc + i.val_configurations_completed, 0))}
                    </span>
                  </div>
                </div>
                <KpiConfigurationBarChart
                  id="kpiConfigurationBarChart"
                  data={configurations}
                  price={false}
                  intl={intl}
                />
              </div>
              <div>
                <div className="flex flex-row justify-between">
                  <div className="p-2">
                    <span className="text-lg text-gray-500 font-bold m-1">
                      {intl.formatMessage({id: "total_amount_kk"})}
                    </span>
                    <span className="text-lg text-gray-700 font-bold m-1">
                      {intl.formatNumber(configurations.reduce((acc, i) => acc + i.amt_completed, 0), currencyOption)}
                    </span>
                  </div>
                </div>
                <KpiConfigurationBarChart
                  id="kpiConfigurationLastBarChart"
                  data={configurations}
                  price={true}
                  intl={intl}
                />
              </div>
            </div> :
            <span className="text-lg text-gray-500 my-32">
            {intl.formatMessage({id: "no_data_available"})}
          </span>
          }
        </PageSection>
      </div> :
      <div className="flex flex-col w-full mb-4 gap-y-5">
        <div className="flex flex-row gap-x-5">
          <Placeholder width="w-1/2" height="h-80"/>
          <Placeholder width="w-1/2" height="h-80"/>
        </div>
      </div>
    }
  </div>
}